import { TTabConfig, TTabsProps } from "../../../dataTypes";

// Used as sample
export const toolbarSample: TTabsProps = {
  menu: {
    type: "tab",
    activeKey: "active",
    items: [
      { key: "all", label: "All" },
      { key: "active", label: "Active" },
      { key: "inactive", label: "Inactive" },
    ],
    onChange: (key?: React.Key) => {
      console.log("切换到", key);
    },
  },
};

export function createProTableTabs({
  tabs,
  activeKey,
  onTabChange,
}: {
  tabs: TTabConfig[];
  activeKey: React.Key;
  onTabChange: (key: React.Key) => void;
}): TTabsProps {
  return {
    menu: {
      type: "tab",
      activeKey: String(activeKey),
      items: tabs.map((tab) => ({
        key: String(tab.key),
        label: tab.label,
      })),
      onChange: (key) => {
        // TS now knows key is string | undefined
        if (key !== undefined) {
          console.log("切换到", key);
          onTabChange(key);
        }
      },
    },
  };
}
